import { defineComponent, ref, toRefs, computed, watch } from 'vue-demi';
import './TimeFormat-a7f5565b.js';
import './dom-53c9635b.js';
import { i as isEqual } from './isEqual-15f4b2f5.js';
import { i as isNil } from './isNull-7ae26d1d.js';
import { t as toArray } from './toArray-93b84b21.js';
import '@vueuse/core';
import { u as useProxyModelValue } from './useProxyModelValue-e18f251e.js';
import '@onereach/styles/screens.json';
import '@onereach/styles/tailwind.config.json';
import { s as script$3, T as TagsOverflow } from './OrTags-44507e58.js';
import { s as script$2 } from './OrSelectControlInput-e0116b29.js';
import { s as script$1 } from './OrSelectPlaceholder-81502228.js';
import { resolveComponent, openBlock, createElementBlock, normalizeClass, withDirectives, createVNode, createSlots, withCtx, renderSlot, createTextVNode, toDisplayString, createElementVNode, vShow, createBlock, createCommentVNode } from 'vue';

const SelectMultipleControlRoot = [
// Layout
'layout-row', 'w-full'];

var script = defineComponent({
  name: 'OrSelectMultipleControl',
  components: {
    OrSelectPlaceholder: script$1,
    OrSelectControlInput: script$2,
    OrTags: script$3
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    model: {
      type: undefined,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    },
    overflow: {
      type: String,
      default: () => TagsOverflow.Hidden
    },
    placeholder: {
      type: String,
      default: undefined
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    enableSearch: {
      type: Boolean,
      default: false
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'reset'],
  expose: ['root', 'focus', 'focused'],
  setup(props, context) {
    // Refs
    const root = ref();
    const searchControl = ref();
    const tags = ref();
    // Props
    const {
      modelValue,
      model,
      options,
      overflow
    } = toRefs(props);
    // State
    const searchModelValue = useProxyModelValue(modelValue, context.emit);
    const focused = computed(() => {
      var _a;
      return (_a = searchControl.value) === null || _a === void 0 ? void 0 : _a.focused;
    });
    // Styles
    const rootStyles = computed(() => ['or-select-multiple-control-v3', ...SelectMultipleControlRoot]);
    // Computed
    const value = computed(() => isNil(model.value) ? [] : toArray(model.value));
    const isEmpty = computed(() => value.value.length === 0);
    const selection = computed(() => {
      if (model.value === undefined || model.value === null) {
        return [];
      }
      return value.value.map(value => options.value.find(option => isEqual(option.value, value))).filter(value => !!value).map(option => ({
        value: option.value,
        label: option.label,
        tagProps: option.disabled && {
          disabled: option.disabled
        }
      }));
    });
    watch(selection, (items, prevItems) => {
      if (items.length != prevItems.length && overflow.value === TagsOverflow.Scroll && tags.value) {
        tags.value.scrollToEnd();
      }
    });
    // Methods
    function focus() {
      if (searchControl.value) {
        searchControl.value.focus();
      }
    }
    return {
      root,
      tags,
      rootStyles,
      searchControl,
      searchModelValue,
      isEmpty,
      selection,
      value,
      focus,
      focused
    };
  }
});

const _hoisted_1 = {
  class: "inline-flex w-fit max-w-full"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrSelectControlInput = resolveComponent("OrSelectControlInput");
  const _component_OrTags = resolveComponent("OrTags");
  const _component_OrSelectPlaceholder = resolveComponent("OrSelectPlaceholder");
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles)
  }, [withDirectives(createVNode(_component_OrTags, {
    ref: 'tags',
    items: _ctx.selection,
    class: "grow",
    disabled: _ctx.disabled,
    "tag-props": {
      variant: _ctx.readonly || _ctx.disabled ? 'tag' : 'reset',
      disabled: _ctx.disabled
    },
    overflow: _ctx.overflow,
    onReset: _cache[1] || (_cache[1] = $event => _ctx.$emit('reset', $event))
  }, createSlots({
    tag: withCtx(({
      item
    }) => [renderSlot(_ctx.$slots, "tag", {
      item: item
    }, () => [createTextVNode(toDisplayString(item.label), 1 /* TEXT */)])]),
    _: 2 /* DYNAMIC */
  }, [_ctx.enableSearch ? {
    name: "tail",
    fn: withCtx(() => [createElementVNode("div", _hoisted_1, [createVNode(_component_OrSelectControlInput, {
      ref: 'searchControl',
      modelValue: _ctx.searchModelValue,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.searchModelValue = $event),
      placeholder: _ctx.isEmpty ? _ctx.placeholder : '',
      readonly: _ctx.readonly,
      disabled: _ctx.disabled
    }, null, 8 /* PROPS */, ["modelValue", "placeholder", "readonly", "disabled"])])]),
    key: "0"
  } : undefined]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["items", "disabled", "tag-props", "overflow"]), [[vShow, !_ctx.isEmpty || _ctx.enableSearch]]), _ctx.isEmpty && !_ctx.enableSearch ? (openBlock(), createBlock(_component_OrSelectPlaceholder, {
    key: 0,
    disabled: _ctx.disabled
  }, {
    default: withCtx(() => [createTextVNode(toDisplayString(_ctx.placeholder), 1 /* TEXT */)]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["disabled"])) : createCommentVNode("v-if", true)], 2 /* CLASS */);
}

script.render = render;
script.__file = "src/components/or-select-v3/partials/or-select-multiple-control/OrSelectMultipleControl.vue";

export { script as s };
